exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ProjectDetail {\n    padding: 0px 1em 1em;\n}\n\n.ProjectDetail-addFormSupervisor {\n    padding-left: 72px;\n}\n\n.ProjectDetail-addButtonSupervisor{\n    margin-left: auto;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/styles/ProjectDetail.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/styles/ProjectDetail.css
// module chunks = 0